/*global RefLike*/
export class RefAlreadyResolvedError extends Error {
    /*istanbul ignore next*/
    constructor(ref) {
        super('Attempting to resolve an already-resolved reference.');
        this.ref = ref;
        Object.setPrototypeOf(this, RefAlreadyResolvedError.prototype);
    }
}
//# sourceMappingURL=ref-already-resolved.error.js.map